// extracted by mini-css-extract-plugin
export var activeCollection = "style-mod--active-collection--f9ed5";
export var categoriesContent = "style-mod--categories-content--23f39";
export var categoryContainer = "style-mod--category-container--04c59";
export var categoryTitle = "style-mod--category-title--b2347";
export var content = "style-mod--content--f4f54";
export var dropBtn = "style-mod--drop-btn--a2e9d";
export var dropdownMenu = "style-mod--dropdown-menu--af870";
export var filterSort = "style-mod--filter-sort--df81a";
export var isActive = "style-mod--is-active--eeaf4";
export var isSelected = "style-mod--is-selected--53c36";
export var mobileDrop = "style-mod--mobile-drop--121a1";
export var notActive = "style-mod--not-active--375e4";
export var notActiveCollection = "style-mod--not-active-collection--09fec";
export var prodImg = "style-mod--prod-img--55c89";
export var productsCategories = "style-mod--products-categories--4af34";
export var roundedCornerns = "style-mod--rounded-cornerns--18e90";
export var show = "style-mod--show--e3111";
export var title = "style-mod--title--20304";